import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Modal,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import CommonDivider from "../../../../../common/components/divider/CommonDivider";
import { CloseModalIcon } from "../../../../../common/components/assets/commonassets/CommonAssets";
import { errorAlert } from "../../../../../common/components/Toasts/Toasts";



export const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "45%",
  bgcolor: "background.paper",
  border: "1px solid gray",
  borderRadius: 6,
  boxShadow: 20,
  p: 2,
};

const CommonAssessmentTestModal = ({ open, onClose, backendData = [] }) => {
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);

  useEffect(() => {
    if (!backendData?.length) return;

    const mapped = backendData.map((item, index) => ({
      id: item.id,
      question: item.question,
      optionTypeId: item.optionTypeId,
      options:
        item.options?.map((opt) => ({
          id: opt.id,
          label: opt.option,
        })) ?? [],
      answer: item.answer ?? "", // backend answer
    }));

    setQuestions(mapped);
    setCurrentQuestion(0);
  }, [backendData]);

  if (!questions.length) return null;

  const current = questions[currentQuestion];
  const isFirst = currentQuestion === 0;
  const isLast = currentQuestion === questions.length - 1;

  return (
    <Modal open={open}>
      <Box sx={ModalStyle}>
        {/* Header */}
        <div className="flex justify-between items-center">
          <div className="flex gap-6 items-center">
            <h1 className="font-semibold text-[18px]">Assessment</h1>
            <p className="inline-flex items-center px-3 py-1 text-sm font-semibold text-blue-700 bg-blue-50 border border-blue-200 rounded-full">
              {currentQuestion + 1} of {questions?.length}
            </p>
          </div>

          <CloseModalIcon
            className="cursor-pointer"
            onClick={() => onClose(false)}
          />
        </div>

        <CommonDivider />

        {/* Question */}
        <h2 className="text-[17px] font-semibold mt-3">
          {currentQuestion + 1}. {current?.question}
        </h2>

        <div className="mt-4 min-h-[200px] space-y-2">
          {/* Free text answer */}
          {current?.optionTypeId === 1 && (
            <div className="border rounded-md p-3 bg-gray-50">
              {current.answer || "No answer available"}
            </div>
          )}

          {/* Radio / Checkbox options */}
          {(current?.optionTypeId === 2 || current?.optionTypeId === 3) &&
            current?.options?.map((opt) => (
              <div
                key={opt.id}
                className="border rounded-md px-3 py-2 bg-gray-50"
              >
                {opt.label}
              </div>
            ))}
        </div>

        {/* Navigation */}
        <div className="flex justify-between items-center pt-6">
          <button
            disabled={isFirst}
            onClick={() => setCurrentQuestion((p) => p - 1)}
            className={`px-5 py-2 rounded-full text-sm border
            ${
              isFirst
                ? "border-gray-200 text-gray-300 cursor-not-allowed"
                : "border-gray-300 text-gray-600 hover:bg-gray-50"
            }`}
          >
            Previous
          </button>

          {!isLast && (
            <button
              onClick={() => setCurrentQuestion((p) => p + 1)}
              className="px-5 py-2 rounded-full text-sm bg-customBlue text-white hover:bg-gray-700"
            >
              Next
            </button>
          )}
        </div>
      </Box>
    </Modal>
  );
};

export default CommonAssessmentTestModal;